import styled from 'styled-components';
import { DynamicExteriorImagePreviewStyled } from '../DynamicExteriorImagePreviewStyled';

export const DynamicExteriorImagePreviewAC = styled(DynamicExteriorImagePreviewStyled)`
    
`;
